/** "1st" / "2nd" / "3rd" / "11th" — a rank as an ordinal, for "3rd of 16". */
export function ordinal(n: number): string {
  const mod100 = n % 100;

  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;

  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}

/** Compact scores for narrow columns; rounding promotes k to M at one million. */
export function formatScore(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value))
    return "—";

  const abs = Math.abs(value);

  if (abs >= 1_000_000) return `${(value / 1_000_000).toFixed(2)}M`;

  if (abs >= 100_000) {
    const thousands = Math.round(value / 1000);

    if (Math.abs(thousands) >= 1000)
      return `${(value / 1_000_000).toFixed(2)}M`;

    return `${thousands}k`;
  }

  if (abs >= 10_000) {
    const oneDecimal = (value / 1000).toFixed(1);

    if (Math.abs(Number(oneDecimal)) >= 100)
      return `${Math.round(value / 1000)}k`;

    return `${oneDecimal}k`;
  }

  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
    value,
  );
}

/** Full-precision integer with thousands separators, for tables. */
export function formatInt(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value))
    return "—";

  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
    value,
  );
}

export function formatCredits(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value))
    return "—";

  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: value >= 100 ? 0 : 1,
  }).format(value);
}
